export default "__VITE_ASSET__72763bda__"